"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitEndingSlashIfExists = void 0;
function omitEndingSlashIfExists(str) {
    return str.replace(/\/+$/, '');
}
exports.omitEndingSlashIfExists = omitEndingSlashIfExists;
//# sourceMappingURL=utils.js.map